import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ErrorHandlingService } from './error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(
    private title: Title,
    private router: Router,
    private errorHandlingService: ErrorHandlingService,
  ) {}

  setTitle(routeSnapshot: ActivatedRouteSnapshot, stateSnapshot: RouterStateSnapshot, overrideTitle?: string) {
    let newTitle = 'Termhub';

    // Check if the current route has a data object with a title property
    if (routeSnapshot.data && routeSnapshot.data.title) {
      newTitle = routeSnapshot.data.title;
    }

    if (overrideTitle && overrideTitle != '') {
      newTitle = overrideTitle;
    }

    if (routeSnapshot.data && routeSnapshot.data.error) {
      this.router.navigateByUrl('/dashboard');
      this.errorHandlingService.showError('Page not found!');
    }
    this.title.setTitle(newTitle);
  }

  getTitle(): string {
    return this.title.getTitle();
  }
}
